/**
 *
 * Copyright © 2017 Easymeeting AS. All rights reserved.
 *
 * This software is produced by Easymeeting AS.
 * Unauthorized redistribution, reproduction, or usage of
 * this software in whole or in part without the express
 * written consent of Easymeeting AS is strictly prohibited.
 */

import { mapActions, mapGetters } from 'vuex';
import { validateJwt } from '@/api/auth';
import { getProfile } from '@/api/profile';
import { $_UTILS } from '@/helpers/utils';

// import Presence from '@/components/Presence';
import appEvents from '@/mixins/appEvents';
// import presenceEvents from '@/mixins/presenceEvents';
// import callEvents from '@/mixins/callEvents';
import deviceEvents from '@/mixins/deviceEvents';
// import controlAppEvents from '@/mixins/controlAppEvents';
import languageMixin from '@/mixins/language';

export default {
  name: 'AppView',
  mixins: [
    appEvents,
    deviceEvents,
    // presenceEvents,
    // callEvents,
    // controlAppEvents,
    languageMixin
  ],
  components: {
    // Presence
  },
  props: {},

  data () {
    return {
      appUpdateAvaliable: false,
      currentContact: null,
      dimension: {
        appHeight: 0,
        appHeightInMeeting: 0
      },
      heartBeatInterval: null,
      isAppReadyCalled: false,
      isPresenceConnecting: false,
      isToastShowing: false,
      isValidating: false,
      noInternet: false,
      showContactInfo: false,
      showingGroupInfo: false,
      showIncoming: false,
      showOutgoing: false,
      showPairing: false,
      toastIconLeft: null,
      toastIconRight: null,
      toastInterval: null,
      toastText: null,
      desktopCheckCounter: 0
    };
  },

  computed: {
    ...mapGetters('AppStore', {
      deviceInfo: 'deviceInfo',
      $_CONFIG: 'config',
      cameraName: 'cameraName',
      countries: 'countries',
      isOauthEnabled: 'isOauthEnabled',
      meetingData: 'meetingData',
      orientation: 'orientation',
      shareStarted: 'shareStarted',
      isDesktopApp: 'isDesktopApp'
    }),
    ...mapGetters('AuthStore', {
      authToken: 'token',
      user: 'profile'
    }),
    ...mapGetters('ContactStore', {
      currentIncomingContact: 'incomingContact',
      currentOutgoingContact: 'outgoingContact',
      userPool: 'userPool'
    }),
    ...mapGetters('ConversationStore', {
      conversationInfo: 'conversationInfo'
    }),
    ...mapGetters(['standBy'])
  },

  created () {
    // this.$router.replace({ name: 'splash' });
    // this.$_NATIVE.appLoaded();
    // if (!this.authToken && this.deviceInfo) {
    //   this.gotoLanding();
    // } else
    if (this.authToken && this.deviceInfo) {
      this.validateToken(true);
    }
    // this.startHeartBeat();
    this.subscribeAppEvents();
    this.subscribeDeviceEvents();
  },
  async mounted () {
    await this.checkIsDesktopApp();
  },
  beforeDestroy () {
    this.unsubscribeAppEvents();
    this.unsubscribeDeviceEvents();
    if (this.heartBeatInterval) {
      clearInterval(this.heartBeatInterval);
    }
  },

  methods: {
    ...mapActions('AppStore', {
      setIsDesktopApp: 'setIsDesktopApp'
    }),
    ...mapActions('AuthStore', {
      setProfile: 'setProfile',
      updateTokenValidity: 'isValid'
    }),
    ...mapActions('ContactStore', {
      initContacts: 'initContacts',
      setIncomingContact: 'setIncomingContact',
      setOutgoingContact: 'setOutgoingContact',
      updateIncomingContact: 'updateIncomingContact',
      updateOutgoingContact: 'updateOutgoingContact'
    }),
    ...mapActions('ConversationStore', {
      removeNotification: 'removeNotification'
    }),
    ...mapActions(['setStandBy']),
    appReady () {
      let dataToNative = {
        appURL: this.$_CONFIG.appconfig.APP_URL,
        audio: this.$_CONFIG.appconfig.audio,
        lang: this.$_CONFIG.appconfig.SITE_DEFAULT_LANGUAGE,
        strings: {},
        theme: {},
        oauthEnabled: this.isOauthEnabled
      };
      if (this.isOauthEnabled) {
        const { REDIRECT_URL_NATIVE, REDIRECT_URL_WEB, PROVIDER_NAME } = this.$_CONFIG.appconfig.OAUTH_CONFIG;
        dataToNative = {
          ...dataToNative,
          oauth: {
            REDIRECT_URL_NATIVE,
            REDIRECT_URL_WEB,
            PROVIDER_NAME
          }
        };
      }
      this.$_NATIVE.appReady(dataToNative);
    },
    async checkIsDesktopApp () {
      await this.setIsDesktopApp(!!window.desktopCapturer);
      this.desktopCheckCounter++;
      if (this.isDesktopApp) {
        this.desktopCheckCounter = 15;
      }
      if (this.desktopCheckCounter < 15) {
        await $_UTILS.waitTimeout(200);
        this.checkIsDesktopApp();
      }
    },
    clearChatNotificationIfNeeded () {
      // if (this.currentRoute.route.name === 'chat' &&
      //     this.conversationInfo && this.conversationInfo.conversationID
      // ) {
      //   this.removeNotification(this.conversationInfo);
      // }
    },
    connectPresence () {
      this.isPresenceConnecting = true;
      this.showToast({
        iconLeft: 'SvgLoading',
        text: this.$t('APP_TEXT_CONNECTING_TO_SERVER'),
        static: true
      });
      this.$refs.presenceServer.connect();
    },
    disconnectPresence () {
      this.$refs.presenceServer.disconnect();
    },
    userInfoToNative () {
      this.$_NATIVE.userLoginStatus({
        status: true,
        authToken: this.authToken,
        profile: this.user
      });
    },
    async fetchUserData () {
      let userData = null;
      try {
        userData = await getProfile();
      } catch (error) {}
      if (userData) {
        if (userData.profile) {
          await this.setProfile(userData.profile);
          if (userData.profile.status === 1) {
            this.onUserOnline();
          }
          if (userData.profile.defaultlanguage) {
            this.onChangeLanguage(userData.profile.defaultlanguage, true);
          }
        }
        if (userData.contacts) {
          await this.initContacts({
            contacts: userData.contacts,
            users: userData.users || []
          });
        }
        this.gotoHome();
        this.userInfoToNative();
        this.onFetchRecentCalls();
      }
    },
    gotoHome () {
      this.sendToControls({
        type: 'task',
        scope: 'app',
        data: {
          task: 'gotoHome'
        }
      });
      this.$router.replace({
        name: 'home'
      });
    },
    gotoLanding () {
      // this.sendToControls({
      //   type: 'task',
      //   scope: 'app',
      //   data: {
      //     task: 'gotoLanding'
      //   }
      // });
      this.$router.replace({
        name: 'landing'
      });
    },
    hideContact () {
      this.showContactInfo = false;
      this.currentContact = null;
      this.clearChatNotificationIfNeeded();
    },
    hideGroupInfo () {
      this.showingGroupInfo = false;
      this.clearChatNotificationIfNeeded();
    },
    hideStandBy () {
      this.setStandBy(false);
    },
    hideToast () {
      this.isToastShowing = false;
      this.toastText = null;
      this.toastIconLeft = null;
      this.toastIconRight = null;
      clearTimeout(this.toastInterval);
    },
    hideIncoming (noDelay) {
      this.sendToControls({
        type: 'task',
        scope: 'app',
        data: {
          task: 'hideIncoming',
          param: noDelay
        }
      });
      const self = this;
      setTimeout(
        () => {
          self.showIncoming = false;
          self.setIncomingContact(null);
        },
        noDelay
          ? 100
          : self.user && self.user.supereasymode
            ? self.$_GLOBAL.Timers.CALL_INFO_DELAY_SUPER_EASY
            : self.$_GLOBAL.Timers.CALL_INFO_DELAY
      );
    },
    hideOutgoing (noDelay) {
      this.sendToControls({
        type: 'task',
        scope: 'app',
        data: {
          task: 'hideOutgoing',
          param: noDelay
        }
      });
      const self = this;
      setTimeout(
        () => {
          self.showOutgoing = false;
          self.setOutgoingContact(null);
        },
        noDelay
          ? 100
          : self.user && self.user.supereasymode
            ? self.$_GLOBAL.Timers.CALL_INFO_DELAY_SUPER_EASY
            : self.$_GLOBAL.Timers.CALL_INFO_DELAY
      );
    },
    openStore () {
      this.$_NATIVE.openInBrowser(
        this.$_CONFIG.appconfig.ANDROID_CAMERA_APP_LATEST_URL
      );
    },
    findDimensions () {
      const heightToReduce = 72;
      this.dimension.appHeight =
        Math.min(
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          ),
          Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        ) - heightToReduce;
      this.dimension.appHeightInMeeting =
        Math.min(
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          ),
          Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
        ) - heightToReduce;
    },
    setBodyHeight ({ inmeeting = false, remove = false }) {
      if (remove) {
        document.body.style.removeProperty('min-height');
      } else {
        document.body.style.setProperty('min-height', `${
          inmeeting ? this.dimension.appHeightInMeeting : this.dimension.appHeight
        }px`);
      }
    },
    showToast (options) {
      this.hideToast();
      if (options) {
        this.isToastShowing = true;
        this.toastText = options.text ? options.text : null;
        this.toastIconLeft = options.iconLeft ? options.iconLeft : null;
        this.toastIconRight = options.iconRight ? options.iconRight : null;
        if (!options.static) {
          const self = this;
          setTimeout(
            () => {
              self.hideToast();
            },
            options.short
              ? this.$_GLOBAL.Timers.TOAST_SHORT
              : this.$_GLOBAL.Timers.TOAST_LONG
          );
        }
      }
    },
    startHeartBeat () {
      if (this.heartBeatInterval) {
        clearInterval(this.heartBeatInterval);
      }
      this.heartBeatInterval = setInterval(() => {
        this.$eventBus.$emit('heart-beat');
      }, 1000);
    },
    async validateToken (startup = false) {
      this.isValidating = true;
      if (!startup) {
        this.showToast({
          iconLeft: 'SvgLoading',
          text: this.$t('APP_TEXT_VALIDATING_TOKEN'),
          static: true
        });
      }
      let result = false;
      try {
        result = await validateJwt();
      } catch (error) {
        result = false;
      }
      await this.updateTokenValidity(result);
      this.isValidating = false;
      if (result) {
        window.location.replace(this.$_CONFIG.appconfig.APP_URL);
      } else {
        this.hideToast();
        // this.gotoLanding();
      }
    }
  }
};
